<template>
    <v-container class="site-map text-left"
                 fluid
                 v-if="facilityTypes && categories">
        <v-row>
            <v-col class="font-size-100">Site Map</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" sm="4">
                <v-row>
                    <v-col class="site-map-title">
                        {{$t('header.about_us')}}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <router-link :to="{name: 'about'}">{{$t('header.about_us')}}</router-link>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4">
                <v-row>
                    <v-col class="site-map-title">
                        {{$t('header.facility')}}
                    </v-col>
                </v-row>
                <v-row v-for="facilityType in facilityTypes">
                    <v-col>
                        <router-link :to="{name: 'facility', params: {facilityTypeId: facilityType.id}}">{{facilityType.name}}</router-link>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4">
                <v-row>
                    <v-col class="site-map-title">
                        {{$t('header.event')}}
                    </v-col>
                </v-row>
                <v-row v-for="category in categories">
                    <v-col>
                        <router-link :to="{name: 'event-list', params: {categoryId: category.id}}">{{category.name}}</router-link>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <router-link :to="{name: 'past-event'}">{{$t('past_event.title')}}</router-link>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4">
                <v-row>
                    <v-col class="site-map-title">
                        {{$t('promotion.title')}}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <router-link :to="{name: 'promotion'}">{{$t('promotion.title')}}</router-link>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'Sitemap',
        data() {
            return {
                facilityTypes: [],
                categories: [],
            };
        },
        mounted() {
            this.getFacilityTypes();
            this.getCategories();
        },
        methods: {
            getFacilityTypes() {
                this.$callAPI('aafb/facility_types/', {}, function (response) {
                    this.facilityTypes = response.body.item_types;
                });
            },
            getCategories() {
                this.$callAPI('hkiarace/event_category/', {}, function (response) {
                    this.categories = response.body.categories;
                })
            },
        },
    }
</script>

<style lang="less">
    .site-map {
        .site-map-title {
            font-weight: bold;
            font-size: 1.2rem;
        }
    }
</style>